
import React, { Component, PropTypes } from 'react';
import Select from 'react-select';
import Translate from '../layout/Translate';


export default class OrderGeneral extends Component {

    componentDidMount() {
        this.props.actions.changeCount(this.props.order.count);
    }

    changeCount(e) {
        this.props.actions.changeCount((e.value)?e.value:1);
    }
    changeEmail(e) {
       //console.info(e.target.value);
        this.props.actions.changeEmail(e.target.value);
    }

    selectDeparture(departure) {
       //console.log(departure);
        this.props.actions.selectDeparture((departure)?departure:{});
    }

    changeOptionCount(option, count, e) {
        this.props.actions.changeOptionCount(option, (e.target.value)?e.target.value:count);
    }


    addOrder() {
        this.props.actions.fetchAddOrderIfNeeded({
            tourId: this.props.order.departure.program_id,
            departureId: this.props.order.departure.id,
            count: this.props.order.count,
            email: this.props.user.email
        });
    }

    render () {
        const { departure } = this.props.order;
        const order = this.props.order;
        const tour = this.props.tour;
        const user = this.props.user;

        let counts = [];

        for (let count = 1; count < 20; count++) {
                counts.push({
                    value: count,
                    label: count
                });
        }



        return (
            <div className="order__form form">
                <div className="form__row">
                    <div className="form__col">
                        <label className="form__label">
                            <Translate slug="order__person__count" />
                        </label>

                        <Select
                            name="form-field-name"
                            className="form__select"
                            value={order.count}
                            options={counts}
                            onChange={this.changeCount.bind(this)}
                        />
                    </div>

                    <div className="form__col">
                        <label className="form__label">
                            <Translate slug="order__email" />
                        </label>
                        <input type="text" value={user.email} onChange={this.changeEmail.bind(this)} className="form__control form__input"/>

                    </div>
                </div>
                <div className="form__row">
                    <div className="form__col">
                        <label className="form__label">
                            <Translate slug="order__departure" />
                        </label>


                        <Select
                            style={{width: 250}}
                            className="form__select"
                            name="form-field-name"
                            value={departure.id}
                            options={tour.departures}
                            labelKey="formated_start_date"
                            valueKey="id"
                            onChange={this.selectDeparture.bind(this)}
                        />
                        {departure.formated_end_date &&
                            <div className="form__comment">
                                <span className="form__subtitle"><Translate slug="order__departure__end" /></span><br/>
                                {departure.formated_end_date}
                            </div>
                        }
                    </div>
                </div>

                {false && (order.options && order.options.length > 0) &&
                <div className="form__row">

                    <div className="form__col">
                        <label className="form__label">
                            <Translate slug="order__options" />
                        </label>
                    </div>
                    <table className="table order__table services">
                        {order.options.map((option, i) =>

                            <tbody key={i}>
                            <tr className=" services__row">
                                <td className=" services__col"></td>
                                <td className=" services__col"><span className="services__title">{option.title}</span></td>
                                <td className=" services__col">
                                    <div className="order__counter counter">
                                        <div className="counter__minus" onClick={this.changeOptionCount.bind(this, option, option.count-1)}></div>
                                        <input className="counter__input" value={option.count} onChange={this.changeOptionCount.bind(this, option, 0)} />
                                        <div className="counter__plus" onClick={this.changeOptionCount.bind(this, option, option.count+1)}></div>
                                    </div>
                                </td>
                                <td className=" services__col">
                                    <span className="services__price">{new Intl.NumberFormat('ru-RU').format(option.price)} {departure.currency_id}</span>
                                </td>
                                <td className=" services__col">
                                    {option.count > 0 &&
                                    <button type="text" className="services__button services__button_active" onClick={this.changeOptionCount.bind(this, option, 0)}><Translate slug="order__option__on" /></button>
                                    }
                                    {option.count < 1 &&
                                    <button type="text" className="services__button"
                                            onClick={this.changeOptionCount.bind(this, option, order.count)}>
                                        <Translate slug="order__option__off" /></button>
                                    }
                                </td>
                            </tr>
                            {option.description &&
                            <tr>
                                <td colSpan="5" className="">
                                    <div className="services__info">
                                        {option.description}
                                    </div>
                                </td>
                            </tr>
                            }
                            </tbody>
                        )}
                    </table>
                </div>
                }






                <div className="form__row">

                    <div className="form__col form__col_12">
                        <label className="form__label form__label_large">
                            <Translate slug="order__comment" />
                        </label>
                        <textarea className="form__control form__control_auto"></textarea>
                    </div>
                </div>
                <div className="form__buttons">
                    <button className={"form__button form__button_success " + ((order.isFetching)?'form__button_fetching':'')} onClick={this.addOrder.bind(this)}>
                        <Translate slug="order__next-step" />
                    </button>
                </div>
            </div>
        );
    }
}














// WEBPACK FOOTER //
// ./src/common/components/order/General.js